import React from "react";
import { API, graphqlOperation } from "aws-amplify";
import BuyCoverTable from "./BuyCoverTable";
import SellShortTable from "./SellShortTable";
import Loading from "_shared/components/Loading/Loading";

function CoreSignalSrength(props) {
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    refreshData();
  }, []);

  React.useEffect(() => {
    if (props.reload) {
      refreshData();
    }
  }, [props.reload]);

  //we are now temporarily excluding tickers from the top 25 (CA, 2022-08-21)
  const excludedTickers = [
    "POSH",
    "EWK",
    "AVLR",
    "BIL",
    "PBJ",
    "LQDH",
    "CHIH",
    "DEF",
    "NLR",
    "CHIE",
    "XTL",
    "BAB",
    "ICSH",
    "SEV",
    "DWNI",
    "DXJS",
    "IHY",
    "BIV",
    "NLS",
    "SLQD",
    "CCRV",
    "NVCR",
    "CTXS",
    "FNDX",
    "SHV",
    "CMF",
    "GRN",
    "VCLO",
    "HYGH",
    "RIGZ",
    "KEUA",
    "DBE",
    "EWL",
    "IGF",
    "QGEN",
    "GVIP",
    "MUB",
    "RUTH",
    "BWX",
    "VEGI",
    "CHIR",
    "BNDD",
    "BBBY",
    "OGI",
    "STIP",
    "NOMD",
    "BCO",
    "EQAL",
    "CAF",
    "BJK",
    "POWW",
    "EMLC",
    "CEW",
    "ERICB",
    "ODV",
    "SJB",
    "ORCC",
    "IDEX",
    "SYPR",
    "BKLN",
    "WRLD",
    "SJR/B",
    "BFI",
    "EFZ",
    "XHR",
    "AAL",
    "DBV",
    "BTF",
    "TCRT",
    "GERN",
    "CHIK",
    "BGFV",
    "LW",
    "ONEM",
    "IVR",
    "LXU",
    "KMLM",
    "EVBG",
    "EUM",
    "PSON",
    "SLY",
    "LNW",
    "ED1",
  ];

  //Retrieve all columns
  const refreshData = async () => {
    setIsLoading(true);
    const data = (
      await API.graphql(
        graphqlOperation(`{
          LONGBOW_SIGNAL_STRENGTH_BUY: data3(limit: 25, where: {algo_eod_CALC_POSITION_LONGBOW_SIGNAL: {_eq: "Buy"}, country: {_eq: "US"}, algo_eod_CALC_TRADE_RANGE_LOW: {_gt: "0"}, algo_eod_CALC_TRADE_RANGE_HIGH: {_gt: "0"}, ticker: {_nin: [${excludedTickers
            .map((obj) => `"${obj}"`)
            .join(
              ",",
            )}]}}, order_by: {algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH: desc}) {
            name
            ticker
            country
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
            algo_eod_CALC_TRADE_RANGE_ODDS
            algo_eod_PX_LAST
            algo_eod_CALC_TRADE_RANGE_LOW
            algo_eod_CALC_TRADE_RANGE_HIGH
            algo_daily_CurrImpVolDiscPrem

          }
          LONGBOW_SIGNAL_STRENGTH_SELL: data3(limit: 25, where: {algo_eod_CALC_POSITION_LONGBOW_SIGNAL: {_eq: "Sell"}, country: {_eq: "US"}, algo_eod_CALC_TRADE_RANGE_LOW: {_gt: "0"}, algo_eod_CALC_TRADE_RANGE_HIGH: {_gt: "0"}, ticker: {_nin: [${excludedTickers
            .map((obj) => `"${obj}"`)
            .join(
              ",",
            )}]}}, order_by: {algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH: desc}) {
            name
            ticker
            country
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
            algo_eod_CALC_TRADE_RANGE_ODDS
            algo_eod_PX_LAST
            algo_eod_CALC_TRADE_RANGE_LOW
            algo_eod_CALC_TRADE_RANGE_HIGH
            algo_daily_CurrImpVolDiscPrem

          }
          TRADE_RANGE_ODDS_BUY: data3(limit: 25, where: {algo_eod_CALC_TRADE_RANGE_ODDS: {_is_null: false}, country: {_eq: "US"}, algo_eod_CALC_TRADE_RANGE_LOW: {_gt: "0"}, algo_eod_CALC_TRADE_RANGE_HIGH: {_gt: "0"}, ticker: {_nin: [${excludedTickers
            .map((obj) => `"${obj}"`)
            .join(",")}]}},order_by: {algo_eod_CALC_TRADE_RANGE_ODDS: desc}) {
            name
            ticker
            country
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
            algo_eod_CALC_TRADE_RANGE_ODDS
            algo_eod_PX_LAST
            algo_eod_CALC_TRADE_RANGE_LOW
            algo_eod_CALC_TRADE_RANGE_HIGH
            algo_daily_CurrImpVolDiscPrem

          }
          TRADE_RANGE_ODDS_SELL: data3(limit: 25, where: {algo_eod_CALC_TRADE_RANGE_ODDS: {_is_null: false}, country: {_eq: "US"}, algo_eod_CALC_TRADE_RANGE_LOW: {_gt: "0"}, algo_eod_CALC_TRADE_RANGE_HIGH: {_gt: "0"}, ticker: {_nin: [${excludedTickers
            .map((obj) => `"${obj}"`)
            .join(",")}]}}, order_by: {algo_eod_CALC_TRADE_RANGE_ODDS: asc}) {
            name
            ticker
            country
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
            algo_eod_CALC_TRADE_RANGE_ODDS
            algo_eod_PX_LAST
            algo_eod_CALC_TRADE_RANGE_LOW
            algo_eod_CALC_TRADE_RANGE_HIGH
            algo_daily_CurrImpVolDiscPrem

          }
          CURR_IMP_VOL_DISC_PREM_BUY: data3(limit: 25, where: {algo_daily_CurrImpVolDiscPrem: {_is_null: false}, country: {_eq: "US"}, algo_eod_CALC_TRADE_RANGE_LOW: {_gt: "0"}, algo_eod_CALC_TRADE_RANGE_HIGH: {_gt: "0"}, ticker: {_nin: [${excludedTickers
            .map((obj) => `"${obj}"`)
            .join(",")}]}},order_by: {algo_daily_CurrImpVolDiscPrem: desc}) {
            name
            ticker
            country
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
            algo_eod_CALC_TRADE_RANGE_ODDS
            algo_eod_PX_LAST
            algo_eod_CALC_TRADE_RANGE_LOW
            algo_eod_CALC_TRADE_RANGE_HIGH
            algo_daily_CurrImpVolDiscPrem
          }
          CURR_IMP_VOL_DISC_PREM_SELL: data3(limit: 25,where: {algo_daily_CurrImpVolDiscPrem: {_is_null: false}, country: {_eq: "US"}, algo_eod_CALC_TRADE_RANGE_LOW: {_gt: "0"}, algo_eod_CALC_TRADE_RANGE_HIGH: {_gt: "0"}, ticker: {_nin: [${excludedTickers
            .map((obj) => `"${obj}"`)
            .join(",")}]}}, order_by: {algo_daily_CurrImpVolDiscPrem: asc}) {
            name
            ticker
            country
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL
            algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH
            algo_eod_CALC_TRADE_RANGE_ODDS
            algo_eod_PX_LAST
            algo_eod_CALC_TRADE_RANGE_LOW
            algo_eod_CALC_TRADE_RANGE_HIGH
            algo_daily_CurrImpVolDiscPrem
          }
        }`),
      )
    ).data;
    console.log(data);

    setData(data);
    setIsLoading(false);
  };
  // console.log(
  //   props.signal,
  //   data[props.signal + "_SELL"],
  //   data[props.signal + "_BUY"],
  // );
  if (isLoading) return <Loading />;
  return (
    <section className="section sector-performance">
      {/* First table headers */}
      <div
        className="table-div table-buy"
        style={{
          float: window.matchMedia("(max-width: 480px)").matches
            ? "center"
            : "left",
        }}
      >
        <div className="section-title buy">
          {props.signal === "LONGBOW_SIGNAL_STRENGTH"
            ? "Buy/Cover"
            : props.signal === "TRADE_RANGE_ODDS"
            ? "Highest Trading Range Odds to the Upside"
            : "Highest Implied Volatility Premium 1D"}
        </div>
        <div className="sub-header-sector">
          <div className="sub-header-index">
            <div className="transparent">.</div>
            <div
              style={{
                paddingLeft: window.matchMedia("(max-width: 480px)").matches
                  ? 10
                  : 20,
              }}
            >
              #
            </div>
          </div>
          <div className="sub-header-index">
            <div className="transparent">.</div>
            <div style={{ textAlign: "center" }}>Description</div>
          </div>
          <div className="sub-header-index">
            <div className="transparent">.</div>
            <div style={{ textAlign: "center" }}>Ticker</div>
          </div>
          <div
            className="sub-header-index"
            style={{
              display: ["LONGBOW_SIGNAL_STRENGTH", "TRADE_RANGE_ODDS"].includes(
                props.signal,
              )
                ? "none"
                : "block",
            }}
          >
            <div className="justify-center">IVOL</div>
            <div className="justify-center">Premium</div>
          </div>
          <div
            className="sub-header-text"
            style={{
              display: ["CURR_IMP_VOL_DISC_PREM", "TRADE_RANGE_ODDS"].includes(
                props.signal,
              )
                ? "none"
                : "block",
            }}
          >
            <div className="justify-center">Core Signal</div>
            <div className="justify-center">Strength</div>
          </div>
          <div
            className="sub-header-index"
            style={{
              display: [
                "LONGBOW_SIGNAL_STRENGTH",
                "CURR_IMP_VOL_DISC_PREM",
              ].includes(props.signal)
                ? "none"
                : "block",
            }}
          >
            <div className="transparent">.</div>
            <div style={{ textAlign: "center" }}>Odds</div>
          </div>
          <div className="sub-header-text">
            <div className="justify-center">Closing</div>
            <div className="justify-center">Price</div>
          </div>
          <div className="sub-header-text">
            <div
              className="justify-center"
              style={{ borderBottom: "1px solid #bbb8b8" }}
            >
              Trading Range
            </div>
            <div className="justify-center">Low</div>
          </div>
          <div className="sub-header-text">
            <div
              className="justify-center"
              style={{ borderBottom: "1px solid #bbb8b8" }}
            >
              Trading Range
            </div>
            <div className="justify-center">High</div>
          </div>
        </div>
        {/* First table data */}
        <div className="sector-performance-content">
          {data[props.signal + "_BUY"]?.length > 0 ? (
            <BuyCoverTable
              signal={props.signal}
              testData={data[props.signal + "_BUY"]}
            />
          ) : (
            <div
              style={{
                fontSize: "12px",
                fontColor: "#bbb8b8",
                margin: "7px auto",
              }}
            >
              No rows to show
            </div>
          )}
        </div>
      </div>
      {/* Second table headers */}
      <div
        className="table-div table-sell"
        style={{
          float: window.matchMedia("(max-width: 480px)").matches
            ? "center"
            : "right",
        }}
      >
        <div className="section-title sell">
          {props.signal === "LONGBOW_SIGNAL_STRENGTH"
            ? "Sell/Short"
            : props.signal === "TRADE_RANGE_ODDS"
            ? "Highest Trading Range Odds to the Downside"
            : "Highest Implied Volatility Discount 1D"}
        </div>
        <div className="sub-header-sector">
          <div className="sub-header-index">
            <div className="transparent">.</div>
            <div
              style={{
                paddingLeft: window.matchMedia("(max-width: 480px)").matches
                  ? 10
                  : 20,
              }}
            >
              #
            </div>
          </div>
          <div className="sub-header-index">
            <div className="transparent">.</div>
            <div style={{ textAlign: "center" }}>Description</div>
          </div>
          <div className="sub-header-index">
            <div className="transparent">.</div>
            <div style={{ textAlign: "center" }}>Ticker</div>
          </div>
          <div
            className="sub-header-index"
            style={{
              display: ["LONGBOW_SIGNAL_STRENGTH", "TRADE_RANGE_ODDS"].includes(
                props.signal,
              )
                ? "none"
                : "block",
            }}
          >
            <div className="justify-center">IVOL</div>
            <div className="justify-center">Discount</div>
          </div>
          <div
            className="sub-header-text"
            style={{
              display: ["CURR_IMP_VOL_DISC_PREM", "TRADE_RANGE_ODDS"].includes(
                props.signal,
              )
                ? "none"
                : "block",
            }}
          >
            <div className="justify-center">Core Signal</div>
            <div className="justify-center">Strength</div>
          </div>
          <div
            className="sub-header-index"
            style={{
              display: [
                "LONGBOW_SIGNAL_STRENGTH",
                "CURR_IMP_VOL_DISC_PREM",
              ].includes(props.signal)
                ? "none"
                : "block",
            }}
          >
            <div className="transparent">.</div>
            <div style={{ textAlign: "center" }}>Odds</div>
          </div>
          <div className="sub-header-text">
            <div className="justify-center">Closing</div>
            <div className="justify-center">Price</div>
          </div>
          <div className="sub-header-text">
            <div
              className="justify-center"
              style={{ borderBottom: "1px solid #bbb8b8" }}
            >
              Trading Range
            </div>
            <div className="justify-center">Low</div>
          </div>
          <div className="sub-header-text">
            <div
              className="justify-center"
              style={{ borderBottom: "1px solid #bbb8b8" }}
            >
              Trading Range
            </div>
            <div className="justify-center">High</div>
          </div>
        </div>
        {/* Second table data */}
        <div className="sector-performance-content">
          {data[props.signal + "_SELL"]?.length > 0 ? (
            <SellShortTable
              signal={props.signal}
              testData={data[props.signal + "_SELL"]}
            />
          ) : (
            <div
              style={{
                fontSize: "12px",
                fontColor: "#bbb8b8",
                margin: "7px auto",
              }}
            >
              No rows to show
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
export default React.memo(CoreSignalSrength);
